module.exports = __webpack_public_path__ + "static/media/share-asset.6cbfa5a1.png";